import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { AuthenticationService } from '../../authentication/authentication/authentication.service';
import { Router } from '@angular/router';
import { LoginService } from '../../authentication/login/login.service';
import { RolesAndPermissionsService } from '../../../../services/roles-and-permissions.service';
import { ResponseObject } from 'src/app/models/response-object.model';
import { PositionUserRequest, UserSaved } from 'src/app/models/user.model';
import { PaginationModel } from 'src/app/models/pagination.model';
import { PaginationComponent } from 'src/app/components/elements/pagination/pagination.component';
import { PermissionTypeEnum } from 'src/app/common/permission-enum';
import { ViewType } from 'src/app/enums/view-type.enum';
import { CompanyRoleResponse } from 'src/app/models/company.model';
import { AccountingReportService } from 'src/app/services/reports/accounting-report.service';
import { HttpErrorResponse } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-select-company',
  templateUrl: './select-company.component.html',
  styleUrls: ['./select-company.component.scss']
})
export class SelectCompanyComponent implements OnInit, AfterViewInit {
  user: UserSaved;
  companies: CompanyRoleResponse[] = [];
  selected: any;
  show = [0, 1, 2, 3, 4, 5];
  pagination = [1, 2, 3, 4, 5];
  newPagination = {
    total: [],
    filter: [],
    pageSize: 6,
    startElement: 0,
    lastElement: 0,
    pageIndex: 0
  };
  start = 1;
  step = 6;
  allowedUser = false;
  templateImg = "https://app.dev.servicios.gt/images/company-avatar2.png";
  templateSrc = "/images/company-avatar2.png";
  filterWord: string = "";
  modalCompany = false;
  modalRequest = false;
  perms = PermissionTypeEnum;
  @ViewChild(PaginationComponent) paginationComponent: PaginationComponent;

  constructor(
    private authService: AuthenticationService,
    private router: Router,
    private loginService: LoginService,
    private roleService: RolesAndPermissionsService,
    private reportService: AccountingReportService,
    private toastService: ToastrService
  ) {
    if (!this.authService.getCurrentUser()) {
      this.router.navigate['authentication/login'];
    }
    var user = JSON.parse(this.authService.getCurrentUser());
    if (user.id == 3186 || user.admin) {
      this.allowedUser = true;
    }
    this.templateImg = roleService.getUrlApi() + "images/company-avatar2.png";
  }

  ngOnInit(): void {
    this.authService.clearCompany();
    this.authService.setViewType(null);
    sessionStorage.removeItem('account-receivable-temp');
    if (typeof window['loadFile'] === 'function') {
      setTimeout(() => {
        window['loadFile']();
      }, 10)
    }
    this.user = JSON.parse(this.authService.getCurrentUser());
    this.companies = Object.assign(this.companies, this.user.companyRoles);
    this.addInAdmin();
    this.companies.forEach((c) => {
      c['activePartner'] = false;
    })
    this.newPagination.total = [...this.companies];
    this.resetPagination();
    this.loginService.getRoleUser().subscribe(
      (response) => {
        this.user.allRolesInCompanies = Object(response);
        localStorage.setItem('user', JSON.stringify(this.user));
      },
      (error) => {
        console.log("Error al obtener los roles del usuario " + error);
      }
    );
    this.update();
    this.getCompanies();
  }

  selectCompany(company) {
    if (company['activePartner']) {
      this.selected = company;
    }
  }

  getCompanies() {
    this.reportService.companiesActivePartner(this.user.id).subscribe({
      next: (response: ResponseObject) => {
        const allowed: { [key: number]: boolean } = {};
        response.data.forEach((c) => {
          allowed[c.companyId] = true;
        });

        this.companies.forEach((p) => {
          if (allowed[p.companyId]) {
            p['activePartner'] = true;
          }
        });

        this.filter();
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error("Error al obtener los permisos");
      }
    });
  }

  addInAdmin() {
    if (this.allowedUser) {
      var tempAdmin = new CompanyRoleResponse();
      tempAdmin.alphanumericId = "ADMIN";
      tempAdmin.companyNIT = "ADMIN";
      tempAdmin.companyName = "Administración";
      tempAdmin.companyId = 0;
      this.companies.unshift(tempAdmin);
    }
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.paginationComponent.reset();
    })
  }

  previous() {
    this.start--;
    this.update();
  }


  filter() {
    this.companies = [...this.user.companyRoles];
    this.companies = this.companies.filter((company) => {
      return (
        company.companyId.toString().includes(this.filterWord) ||
        company.companyName.toLowerCase().includes(this.filterWord.toLowerCase()) ||
        company.alphanumericId.toLowerCase().includes(this.filterWord.toLowerCase()) ||
        company.companyNIT.includes(this.filterWord)
      );
    });
    if ((!this.filterWord || this.filterWord.toLowerCase() == 'admin') && this.allowedUser) {
      var tempAdmin = new CompanyRoleResponse();
      tempAdmin.alphanumericId = "ADMIN";
      tempAdmin.companyNIT = "ADMIN";
      tempAdmin.companyName = "Administración";
      tempAdmin.companyId = 0;
      this.companies.unshift(tempAdmin);
    }
    this.start = 1;
    this.newPagination.total = [...this.companies];
    this.resetPagination();
    this.paginationComponent.reset();
    this.update();
  }

  next() {
    this.start++;
    this.update();
  }

  select(index: number) {
    this.start = this.pagination[index];
    this.update();
  }

  update() {
    if (this.start > 3) {
      this.pagination = [this.start - 2, this.start - 1, this.start, this.start + 1, this.start + 2];
    } else {
      this.pagination = [1, 2, 3, 4, 5];
    }
    let init = this.start * this.step;
    this.show = [];
    for (let i = this.step; i > 0; i--) {
      this.show.push(init - i);
    }
  }

  sendCompany() {
    this.authService.setCurrentCompanyId(this.selected.companyId);
    this.authService.setCurrentCompany(JSON.stringify(this.selected));
    this.authService.setViewType(ViewType.NORMAL);
    this.roleService.getUserPosition(this.user.id + '').subscribe({
      next: (response: ResponseObject) => {
        var userPosition = response.data;
        if (userPosition.length > 0) {
          this.authService.setUserPosition(userPosition);
          this.roleService.getRolePermissions(userPosition[0].positionRoleId).subscribe({
            next: (response: ResponseObject) => {
              if (response.data.length > 0) {
                this.authService.setPermissions(response.data);
              }
              this.router.navigate(['/']);
            },
            error: (error) => {
              this.router.navigate(['/']);
            }
          });
        } else {
          this.router.navigate(['/']);
        }
      },
      error: (error) => {
        this.router.navigate(['/']);
      }
    });
  }

  goToInAdmin() {
    this.authService.setViewType(ViewType.INADMIN);
    this.authService.setCurrentCompanyId(809);
    this.roleService.getUserPosition(this.user.id + '').subscribe({
      next: (response: ResponseObject) => {
        var userPosition = response.data;
        if (userPosition.length > 0) {
          this.authService.setUserPosition(userPosition);
          this.roleService.getRolePermissions(userPosition[0].positionRoleId).subscribe({
            next: (response: ResponseObject) => {
              if (response.data.length > 0) {
                console.log(response.data, "ejemplo");
                this.authService.clearCompany();
                this.authService.setPermissions(response.data);
                this.router.navigate(['/in-admin/upload-dte']);
              } else {
                this.authService.clearCompany();
                this.router.navigate(['/in-admin/upload-dte']);
              }
            },
            error: (error) => {
              this.toastService.error("Error al obtener los permisos del usuario");
            }
          });
        } else {
          this.router.navigate(['/in-admin/upload-dte']);
        }
      },
      error: (error) => {
        this.toastService.error("Error al obtener los datos del usuario");
      }
    });
  }

  closeModalCompany(company) {
    this.modalCompany = false;
  }

  closeModalRequest(company) {
    this.modalRequest = false;
  }

  resetPagination() {
    this.newPagination.pageIndex = 0;
    this.updatePagination();
  }

  updatePagination() {
    const start = this.newPagination.pageIndex * this.newPagination.pageSize;
    const end = start + this.newPagination.pageSize;
    this.newPagination.filter = this.newPagination.total.slice(start, end);
  }

  onPaginationChanged(event: any) {
    this.newPagination.pageIndex = event.pageIndex;
    this.updatePagination();
  }

  logout() {
    this.authService.logout();
    this.router.navigate(['/authentication/login']);
  }
}
